<template>
  <task-list-view type="ccMe" />
</template>

<script>
import TaskListView from './components/TaskListView.vue'

export default {
  name: 'WflowCcMe',
  components: { TaskListView }
}
</script>
